

// -- Get Our Stores
import { sessionStore } from './store.js';

// -- Layouts
import CustomerLayout from './views/customer/layout.svelte'
import PublicLayout from './views/public/layout.svelte'

// -- Components Public
import Login from './views/public/login.svelte'
import Contact from './views/public/contact.svelte'
import Logout from './views/public/logout.svelte'
import Terms from './views/public/terms.svelte'

// -- Components Guarded
import Dashboard from './views/customer/dashboard.svelte'
import MembersCard from './views/customer/card.svelte'
import NewsIndex from './views/customer/news.svelte'
import EventsIndex from './views/customer/events.svelte'
import StoresIndex from './views/customer/store-finder.svelte'
import LatestOffers from './views/customer/offers.svelte'

// -- Components Guarded - Xmas Game
import XmasHub from './views/xmas-new/hub.svelte'
import XmasGameOne from './views/xmas/game-1.svelte'

let isLoggedIn = false;



sessionStore.subscribe(session => {
  console.log('sessionStore', session)
  isLoggedIn = !!session
});

const customerIsRegistered = () => {
  return isLoggedIn;
}

/*

Public Routes:

/login        -- Register/Login just card number input
/contact      -- Contact

Guarded Routes:

/             -- Customer Dashboard
/card         -- My Card ( Awaiting API Info for barcode )
/offers       -- Latest offers
/news         -- Latest News ( Single is handled here too )
/events       -- Latest News ( Single is handled here too )
/stores       -- Store Finder
/stores/:id   -- Store Specific page
/xmas/day-1   -- Xmas Day 1

*/

const routes = [
  {
    name: '/',
    layout: CustomerLayout,
    component: Dashboard,
    onlyIf: { guard: customerIsRegistered, redirect: '/login' },
  },
  {
    name: 'my-card',
    title: 'My Card',
    layout: CustomerLayout,
    component: MembersCard,
    onlyIf: { guard: customerIsRegistered, redirect: '/login' },
  },

  {
    name: 'offers',
    title: 'Member Offers',
    layout: CustomerLayout,
    component: LatestOffers,
    onlyIf: { guard: customerIsRegistered, redirect: '/login' },
  },

  {
    name: 'news',
    title: 'News',
    component: CustomerLayout,
    onlyIf: { guard: customerIsRegistered, redirect: '/login' },
    nestedRoutes: [
      { name: 'index', component: NewsIndex },
    ]
  },

  {
    name: 'events',
    title: 'Events',
    component: CustomerLayout,
    onlyIf: { guard: customerIsRegistered, redirect: '/login' },
    nestedRoutes: [
      { name: 'index', component: EventsIndex },
    ]
  },

  {
    name: 'store-finder',
    title: 'Store Locator',
    component: CustomerLayout,
    onlyIf: { guard: customerIsRegistered, redirect: '/login' },
    nestedRoutes: [
      { name: 'index', component: StoresIndex },
    ]
  },

  {
    name: 'xmas/hub',
    title: 'Christmas Fame',
    component: XmasHub,
    onlyIf: { guard: customerIsRegistered, redirect: '/login' }
  },


  {
    name: 'xmas-new/hub',
    title: 'Christmas Fame',
    component: XmasHub,
    onlyIf: { guard: customerIsRegistered, redirect: '/login' }
  },

  {
    name: 'login',
    title: 'Register',
    component: Login,
    layout: PublicLayout
  },
  {
    name: 'logout',
    title: 'Logout',
    component: Logout,
    layout: PublicLayout
  },
  {
    name: 'contact',
    title: 'Contact Us',
    component: Contact,
    layout: PublicLayout
  },
  {
    name: 'terms',
    title: 'Terms & Conditions',
    component: Terms,
    layout: PublicLayout
  },
];

export { routes };
